module.exports = __webpack_public_path__ + "static/media/Montserrat-VariableFont_wght.e6cb49ef.ttf";